/* eslint-disable arrow-body-style */

import React, { useRef, useMemo, useState, useEffect, useImperativeHandle } from 'react';
import classnames from 'classnames';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import InfoBubble from '@gp/components/InfoBubble';
import useChartResize from '@gp/hooks/useChartResize';
import { getNumberValue, getPercentagePieChartSeriesData } from './utils';
import { BASE_PERCENTAGE_PIE_CHART_OPTIONS } from './constants';

import type { PercentageCircleInstance, PercentageCircleProps, PercentageCirclePieChartOption } from './types';

import './index.scss';

echarts.use([PieChart, CanvasRenderer]);

const PercentageCircle: React.ForwardRefRenderFunction<PercentageCircleInstance, PercentageCircleProps> = (
  props,
  ref,
) => {
  const { style, className, value: valueFromProps } = props;

  const rootNode = useRef<HTMLDivElement>(null);

  const chartInstance = useRef<any>(null);

  const [value, setValue] = useState<number>(() => getNumberValue(valueFromProps));

  const chartOption = useMemo<PercentageCirclePieChartOption>(() => {
    return {
      ...BASE_PERCENTAGE_PIE_CHART_OPTIONS,
      series: [
        {
          // @ts-ignore
          ...BASE_PERCENTAGE_PIE_CHART_OPTIONS?.series?.[0],
          data: getPercentagePieChartSeriesData(value),
        },
      ],
    };
  }, [value]);

  useChartResize(chartInstance);

  useImperativeHandle(ref, () => ({}), []);

  useEffect(() => {
    setValue(getNumberValue(valueFromProps));
  }, [valueFromProps]);

  useEffect(() => {
    if (rootNode.current) {
      chartInstance.current = echarts.init(rootNode.current);
      if (chartInstance.current) {
        chartInstance.current.setOption(chartOption);
      }
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.dispose();
      }
    };
  }, [chartOption]);

  return (
    <InfoBubble
      customBubbleContent={<span className="globalpedia-modal-font14">% of Dev Budget to Launch</span>}
      DomOrText={
        <div style={style} className={classnames('percentage-circle', className)}>
          <div ref={rootNode} style={{ width: '100%', height: '100%' }}></div>
          <span className="percentage-label">{(value as any) === '' ? '-' : `${value}%`}</span>
        </div>
      }
    />
  );
};

export default React.memo(React.forwardRef(PercentageCircle));
